import { jsx as _jsx } from "react/jsx-runtime";
import StandardError from '../app-active-error/StandardError';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { redirectToUrl } from '../utils/redirectToUrl';
import { learnAboutPartners } from '../signup-completed-redirection/productLinks';

const NoPartnerPortalsErrorView = () => {
  const dispatch = useDispatch();
  const handleButtonClick = useCallback(() => dispatch(redirectToUrl(learnAboutPartners())), [dispatch]);
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.NoPartnerPortalsError,
    handleButtonClick: handleButtonClick
  });
};

export default NoPartnerPortalsErrorView;